import { Modal } from "antd";
import ButtonLoader from "../../../../../../UI/Loaders/Loaders";
import { Document, Page, pdfjs } from "react-pdf";
import { Dispatch, SetStateAction, useState } from "react";
// Required for pdfjs worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
interface ViewMandateTemplateProm {
  showMandateTemplateModal: boolean;
  setShowMandateTemplateModal: Dispatch<SetStateAction<boolean>>;
  mandateTemplate: {
    data: {
      file_url: string;
      file_name: string;
    };
  };
  handleDownload: (isTemplate: boolean) => void;
  isDownloading: boolean;
}

const ViewMandateTemplate = ({
  mandateTemplate,
  handleDownload,
  isDownloading,
  showMandateTemplateModal,
  setShowMandateTemplateModal,
}: ViewMandateTemplateProm) => {
  const [numPages, setNumPages] = useState<number | null>(null);

  const file_url = mandateTemplate?.data?.file_url + `.pdf`;

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };
  return (
    <Modal
      title=""
      width={950}
      open={showMandateTemplateModal}
      zIndex={9990}
      onCancel={() => setShowMandateTemplateModal(false)}
      footer={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <button
            key="cancel"
            className="btn btn-secondary"
            onClick={() => {
              setShowMandateTemplateModal(false);
            }}
          >
            Cancel
          </button>
          <button
            key="cancel"
            className="btn advancly-btn"
            onClick={() => handleDownload(true)}
          >
            {isDownloading ? "Downloading..." : "Download"}
          </button>
        </div>
      }
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {isDownloading ? (
          <ButtonLoader />
        ) : (
          <>
            {/* Image preview */}
            {file_url?.endsWith("png") ||
              (file_url?.endsWith("jpg") && (
                <img
                  src={file_url}
                  alt="Preview"
                  style={{
                    maxWidth: "1000px",
                    maxHeight: "800px",
                    objectFit: "contain",
                  }}
                />
              ))}

            {/* PDF preview (react-pdf) */}
            {file_url?.endsWith(".pdf") && (
              <div
                style={{
                  width: "1000px",
                  height: "800px",
                  overflow: "auto",
                }}
              >
                <Document
                  file={file_url}
                  onLoadSuccess={onDocumentLoadSuccess}
                  loading={<ButtonLoader />}
                >
                  {Array.from(new Array(numPages), (el, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      width={900}
                    />
                  ))}
                </Document>
              </div>
            )}

            {/* Word/Excel/PowerPoint */}
            {(file_url?.includes("word") ||
              file_url?.includes("excel") ||
              file_url?.includes("presentation")) && (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                  file_url,
                )}`}
                width="1000"
                height="800"
                style={{ border: "none" }}
                title="Office Document Viewer"
              />
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export default ViewMandateTemplate;
